import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.css";
// All Components
import Header from "./components/Header/header";
import NotFound from "./components/404Page/NotFound";
import Footer from "./components/Footer/footer";
import ScrollToTopButton from "./components/ScrollToTop/ScrollToTopButton";
import ContactUs from "./components/Contact/ContactUs";

// Home Page
import HomeSlider1 from "./Page/Home/Slider1/HomeSlider1";
import Box1Avalon from "./Page/Home/Canaan/Box1Avalon/box1avalon";
import CanaanTopProductComponent from "./Page/Home/Canaan/CanaanTopProducts/CanaanTopProducts";
import HomeSlider2 from "./Page/Home/Slider2/HomeSlider2";
import Box1JasMiner from "./Page/Home/JasMiner/Box1JasMiner/Box1JasMiner";
import JasMinerFeatures from "./Page/Home/JasMiner/JasMinerFeatures/JasMinerFeatures";
import JasMinerTopProductComponent from "./Page/Home/JasMiner/JasMinerTopProducts/JasMinerTopProducts";
import HomeSlider3 from "./Page/Home/Slider3/HomeSlider3";
import AnexMinerET5 from "./Page/Home/AnexMiner/AnexMinerET5/AnexMinerET5";
import AnexMinerTopProductComponent from "./Page/Home/AnexMiner/AnexMinerTopProducts/AnexMinerTopProducts";
import CanaanVideo from "./Page/Home/Canaan/CanaanVideo/CanaanVideo";
import HomeSlider4 from "./Page/Home/Slider4/HomeSlider4";
import GoldenBannerFullScreenImage from "./Page/Home/GoldenBanner/GoldenBanner";
import IPolloTopProductsComponents from "./Page/Home/iPollo/iPolloTopProducts/iPolloTopProducts";
import BackgroundImageFace2 from "./Page/Home/BackImage/BackImage";
import CanaanBannerFullScreenImageProduct from "./Page/Products/ProductDetailView/ProductBannar/CanaanBanner";

//ProductView


function App() {
  return (
    <Router basename="/">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<NotFoundPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/product-view" element={<ProductViewPage />} />
      </Routes>
    </Router>
  );
}

function Home() {
  return (
    <>
      <Header />
      <HomeSlider1 />
      <Box1Avalon />
      <CanaanTopProductComponent />
      <HomeSlider2 />
      <JasMinerFeatures />
      <Box1JasMiner />
      <JasMinerTopProductComponent />
      <HomeSlider3 />
      <AnexMinerET5 />
      <AnexMinerTopProductComponent />
      <CanaanVideo />
      <HomeSlider4 />
      <IPolloTopProductsComponents />
      <GoldenBannerFullScreenImage />
      <BackgroundImageFace2 />
      <ScrollToTopButton />
      <Footer />
    </>
  );
}

function NotFoundPage() {
  return (
    <>
      <Header />
      <NotFound />
      <Footer />
    </>
  );
}


function ContactPage() {
  return (
    <>
      <Header />
      <ContactUs />
      <Footer />
    </>
  );
}


function ProductViewPage() {
  return (
    <>
      <Header />
      <CanaanBannerFullScreenImageProduct />
      <Footer />
    </>
  );
}

export default App;
